export default class DateTimeHelper  {
    public static getPreviousBusinessDay() {
        var workingDate = new Date();
        workingDate.setDate(workingDate.getDate() - 1);
        while (workingDate.getDay() === 6 || workingDate.getDay() === 0) {
            workingDate.setDate(workingDate.getDate() - 1);
        }

        return workingDate;
    }
}